import type { ReactElement, ReactNode } from 'react';
import { useEffect, useState } from 'react';

import { useMenuLock } from '~services/api/hooks/menu.hooks';

export interface WrapperFunctionParams {
  isLockedByUser?: boolean;
  isLockedByDifferentUser?: boolean;
  msgLockedBy?: string;
}

export type MenuLockWrapperProps = {
  children: (params: WrapperFunctionParams) => ReactNode;
  onFailure: () => void;
};

export const MenuLockWrapper = ({ children, onFailure }: MenuLockWrapperProps) => {
  const [isLockedByUser, setIsLockedByUser] = useState(false);
  const [isLockedByDifferentUser, setIsLockedByDifferentUser] = useState(false);

  // Define: lock menu query
  const { data: lockData, error } = useMenuLock({});

  useEffect(() => {
    if (error) onFailure();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  // Trigger: set locks once lockData is available
  useEffect(() => {
    setIsLockedByUser(lockData?.status === 'done' || false);
    setIsLockedByDifferentUser(lockData?.status === 'locked' || false);
  }, [lockData]);

  return children({
    isLockedByUser,
    isLockedByDifferentUser,
    msgLockedBy: isLockedByDifferentUser ? lockData.info : undefined,
  }) as unknown as ReactElement;
};
